import { render, staticRenderFns } from "./BaseCharts.vue?vue&type=template&id=026bc4e4&scoped=true"
import script from "./BaseCharts.vue?vue&type=script&lang=js"
export * from "./BaseCharts.vue?vue&type=script&lang=js"
import style0 from "./BaseCharts.vue?vue&type=style&index=0&id=026bc4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026bc4e4",
  null
  
)

export default component.exports